import { useMyAccountContext } from "../../Contexts/MyAccountContext";
import SignOutModal from "../../Components/SignOutModal";
import { useAuth } from "../../Contexts/AuthContext";
import Button from "../../Components/Button";
import Switch from "@mui/material/Switch";
import Alert from "./Alert";
import dayjs from "dayjs";
import { NewReleasesRounded, VerifiedRounded } from "@mui/icons-material";

const MyAccount = () => {
  const {
    setDisplaySignOutModal,
    displaySignOutModal,
    handleSignOut,
    setShowModal,
    isLoading,
    navigate,
    setType,
    memberStatus,
  } = useMyAccountContext();
  const { userData, user } = useAuth();

  const handleClose = () => {
    setShowModal(false);
  };

  const handleCloseSignout = () => {
    setDisplaySignOutModal(false);
  };

  let kycButton = null;
  let displayKycStatus = null;
  if (memberStatus.isKycVerified === false) {
    if (
      memberStatus.kycStatus === 'Verified' || memberStatus.kycStatus === 'UnderReview' || memberStatus.kycStatus === 'Rejected' //by eqb; will return to maxicare
    ) {
      kycButton = (
        <div className="w-full text-center mt-2">
          <p>Your KYC application is currently under review.</p>
        </div>
      );
      displayKycStatus = (
        <p className="mt-1 bg-orange-500 text-white inline-block px-3 rounded-full ">
          <span className="flex flex-row items-center">
            <NewReleasesRounded fontSize="inherit" />
            <span className="ml-2">Not Verified</span>
          </span>
        </p>
      );
    } else if (memberStatus.kycStatus === "Returned") {
      kycButton = (
        <>
          <Button
            className={`h-12 w-full transition ease-in-out delay-75 rounded-xl border text-white my-3`}
            onClick={() => navigate("/verification")}
          >
            Resubmit KYC
          </Button>
          <p className="w-full text-start">
            Your application was returned because:{" "}
            <ol>
              {memberStatus.kycReason
                ?.split(" || ")
                .map((sentence) => sentence.trim())
                .map((message) => (
                  <li
                    className="list-decimal ml-8 font-semibold text-red-600"
                    key={message}
                  >
                    {message}
                  </li>
                ))}
            </ol>
          </p>
        </>
      );
      displayKycStatus = (
        <p className="mt-1 bg-orange-500 text-white inline-block px-3 rounded-full ">
          <span className="flex flex-row items-center">
            <NewReleasesRounded fontSize="inherit" />
            <span className="ml-2">Not Verified</span>
          </span>
        </p>
      );
    } else {
      kycButton = (
        <Button
          className={`h-12 w-full transition ease-in-out delay-75 rounded-xl border text-white my-3`}
          onClick={() => navigate("/verification")}
        >
          Submit KYC
        </Button>
      );
      displayKycStatus = (
        <p className="mt-1 bg-orange-500 text-white inline-block px-3 rounded-full ">
          <span className="flex flex-row items-center">
            <NewReleasesRounded fontSize="inherit" />
            <span className="ml-2">Not Verified</span>
          </span>
        </p>
      );
    }
  }
  if (
    memberStatus.isKycVerified === true &&
    memberStatus.kycStatus === "Approved"
  ) {
    displayKycStatus = (
      <p className="bg-blue-700 text-white inline-block px-3 rounded-full ">
        <span className="flex flex-row items-center">
          <VerifiedRounded fontSize="inherit" />
          <span className="ml-2">KYC Verified</span>
        </span>
      </p>
    );
  }

  return (
    <div className="flex flex-col items-center min-h-screen max-w-screen sm:bg-[#E7EEFA] ">
      <div className="bg-white w-screen mb-[56px] sm:my-24 sm:w-148 h-auto rounded-xl">
        <div className="grid grid-cols-1 divide-y">
          <div className="text-center text-md font-bold mb-3 mt-3">Account</div>
          <div className="flex flex-row">
            <div className="flex flex-col w-full">
              <div className="p-4">
                <div className="flex flex-row">
                  <div className="flex flex-col w-full">
                    <div className="mb-3">
                      <p className="text-xl font-semibold">
                        {user?.first_name + " " + user?.last_name}
                      </p>
                      <p className="text-[#60656D]">
                        {userData[0]
                          ? `Member since ${dayjs(
                              userData[0]?.plan.origStartDate
                            ).format("MMMM DD, YYYY")}`
                          : null}
                      </p>
                      {displayKycStatus}
                    </div>

                    <div className="mb-3 w-full bg-white border rounded-md p-3">
                      <p className="text-lg font-semibold">
                        Personal Information
                      </p>
                      <p className="mt-2 text-[#60656D]">Name</p>
                      <p className="">
                        {user?.first_name + " " + user?.last_name}
                      </p>
                      <p className="text-[#60656D]">Birthday</p>
                      <p className="">
                        {dayjs(user?.dateOfBirth).format("MM/DD/YYYY")}
                      </p>
                    </div>

                    <div className="mb-3 w-full bg-white border rounded-md p-3">
                      <p className="text-lg font-semibold">
                        Account Information
                      </p>

                      <div className="flex flex-row mt-2">
                        <div className="flex flex-col flex-grow">
                          <p className="text-[#60656D]">Mobile number</p>
                          <p className="">{user?.PhoneNumber}</p>
                        </div>

                        <div
                          className="w-12 h-8 flex items-center justify-center border rounded cursor-pointer"
                          onClick={() => {
                            setType("mobile number");
                            setShowModal(true);
                          }}
                        >
                          <p className="">Edit</p>
                        </div>
                      </div>

                      <div className="flex flex-row mt-2">
                        <div className="flex flex-col flex-grow">
                          <p className="text-[#60656D]">Email Address</p>
                          <p className="">
                            {user?.email !== ""
                              ? user?.email
                              : "Your account is currently not linked to any email."}
                          </p>
                        </div>

                        <div
                          className="w-12 h-8 flex items-center justify-center border rounded cursor-pointer"
                          onClick={() => {
                            setType("email address");
                            setShowModal(true);
                          }}
                        >
                          <p className="">Edit</p>
                        </div>
                      </div>
                    </div>

                    <div className="mb-3 w-full bg-white border rounded-md p-3">
                      <p className="text-lg font-semibold">Notifications</p>

                      <div className="flex flex-row mt-2  ">
                        <div className="flex flex-col flex-grow ">
                          <p className="">SMS Notification</p>
                        </div>
                        <div className="">
                          <Switch size="small" disabled defaultChecked />
                        </div>
                      </div>

                      <div className="flex flex-row mt-2  ">
                        <div className="flex flex-col flex-grow">
                          <p className="">Email Notification</p>
                        </div>
                        <div className="">
                          <Switch size="small" disabled defaultChecked />
                        </div>
                      </div>
                    </div>

                    <div className="bg-white flex-grow" />

                    <div className="flex flex-col sm:items-end items-center w-full">
                      <Button
                        className={`h-12 w-full transition ease-in-out delay-75 rounded-xl bg-white border`}
                        onClick={() => setDisplaySignOutModal(true)}
                      >
                        Sign out
                      </Button>
                      {kycButton}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SignOutModal
        open={displaySignOutModal}
        onClose={handleCloseSignout}
        onSignOut={handleSignOut}
        isLoading={isLoading}
      />
      <Alert onClose={handleClose} />
    </div>
  );
};

export default MyAccount;
